import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdDone } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './DeleteAccountConfirmedCardStyles';
import {
    Button,
    Container
} from '@mui/material';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
}

const DeleteAccountConfirmedCard: React.FC<Props> = props => {

    const { classes } = useStyles()
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = '/home';
        history.push(path);
    }

    return (
        <AuthPage
            title="Your account has been successfully deleted!"
            icon={<MdDone />}
            iconTone="ok"
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Go To Home</button>}>
            <p>Please click on the button below to return to the home page.</p>
        </AuthPage>
    )

}


const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(DeleteAccountConfirmedCard);